var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandingLogoThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 169,
    viewBox: "0 0 168 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.535 0.229492H0.207886V24.4344H143.665C128.446 9.46473 107.569 0.229492 84.535 0.229492ZM160.667 48.249H0.207886V72.454H168C166.771 63.9043 164.26 55.7689 160.667 48.249ZM0.207886 120.864V96.659H168C166.771 105.209 164.26 113.344 160.667 120.864H0.207886ZM0.207886 144.679V168.884H84.5349C107.569 168.884 128.446 159.648 143.665 144.679H0.207886Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingLogoThumbnail);
export default __webpack_public_path__ + "static/media/branding-logo-thumbnail.fcd9a3b6e0e8a3a970b5fb2d971ef2e9.svg";
export { ForwardRef as ReactComponent };